import styled from 'styled-components';

export const PDFContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
`;

export const PDFEmbed = styled.embed`
    width: 100%;
    height: 100%;
    min-height: 500px;
    border: none;
`;
